
<div [ngClass]="customWidthCss">
  <p>
    <up-date-picker class="longer"
      dateSelection="isoDate"
      [maxDate]="maxDateValue"
      [minDate]="minDateValue"
      (dateSelectionChanged)="onDateChange($event)"
      [dateSelection]="date">
      <up-text-field class="longer"
        [errorState]="dateState ? dateState : errorState"
        [fieldLabel]="placeholder"
        [fieldMessage]="message">
        <input type="text"
          placeholder="{{placeholder ? 'MM/DD/YYYY' : 'Date'}}"
          [disabled]="disabledInput"
          (blur)="onBlur()"
           />
        <up-icon name="event"></up-icon>
      </up-text-field>
    </up-date-picker>
  </p>
</div>
